// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Листування» (Correspondence, ключ `correspondence`, група `office`). */
export const correspondenceManifest: IModuleManifest = {
  key: 'correspondence',
  group: 'office',
  slug: 'correspondence',
  prefix: 'COR',
  name: { en: 'Correspondence', uk: 'Листування' },
  entities: [
    { key: 'correspondence', slug: 'correspondence', name: { en: 'Correspondence', uk: 'Листування' }, main: true },
    { key: 'letter_recipient', slug: 'letter-recipient', name: { en: 'Letter Recipients', uk: 'Одержувачі' }, main: false },
    { key: 'letter_reply', slug: 'letter-reply', name: { en: 'Letter Replies', uk: 'Відповіді' }, main: false },
    { key: 'letter_attachment', slug: 'letter-attachment', name: { en: 'Letter Attachments', uk: 'Вкладення' }, main: false },
    { key: 'letter_registration', slug: 'letter-registration', name: { en: 'Letter Registrations', uk: 'Реєстрації' }, main: false },
    { key: 'letter_status', slug: 'letter-status', name: { en: 'Letter Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/correspondenceSlice').then((m) => m.correspondenceSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
